import { Colour } from 'components/variables'
import { AnyAction } from 'redux'
import { getRandomColor, getRandomPatternType } from '../../utils/colour'
import { getCdnUrl } from '../api/cdn'

export enum PatternType {
  grape = 'grape',
  banana = 'banana',
  flamingo = 'flamingo',
  sprinkles = 'sprinkles',
  sprinkies = 'sprinkies',
}

const images: Array<[PatternType, Colour, string]> = [
  [
    PatternType.banana,
    Colour.turquoise,
    getCdnUrl('pattern-banana-turquoise.jpg'),
  ],
  [
    PatternType.banana,
    Colour.lightTurquoise,
    getCdnUrl('pattern-banana-turquoise.jpg'),
  ],
  [PatternType.banana, Colour.mint, getCdnUrl('pattern-banana-mint.jpg')],
  [PatternType.banana, Colour.green, getCdnUrl('pattern-banana-green.jpg')],
  [PatternType.banana, Colour.purple, getCdnUrl('pattern-banana-purple.jpg')],
  [PatternType.banana, Colour.pink, getCdnUrl('pattern-banana-pink.jpg')],
  [PatternType.banana, Colour.blue, getCdnUrl('pattern-banana-blue.jpg')],
  [
    PatternType.banana,
    Colour.steelBlue,
    getCdnUrl('pattern-banana-steelblue.jpg'),
  ],
  [PatternType.banana, Colour.yellow, getCdnUrl('pattern-banana-yellow.jpg')],
  [PatternType.banana, Colour.orange, getCdnUrl('pattern-banana-orange.jpg')],
  [
    PatternType.banana,
    Colour.lightPink,
    getCdnUrl('pattern-banana-light-pink.jpg'),
  ],
  [
    PatternType.grape,
    Colour.turquoise,
    getCdnUrl('pattern-grape-turquoise.jpg'),
  ],
  [
    PatternType.grape,
    Colour.lightTurquoise,
    getCdnUrl('pattern-grape-turquoise.jpg'),
  ],
  [PatternType.grape, Colour.mint, getCdnUrl('pattern-grape-mint.jpg')],
  [PatternType.grape, Colour.green, getCdnUrl('pattern-grape-green.jpg')],
  [PatternType.grape, Colour.purple, getCdnUrl('pattern-grape-purple.jpg')],
  [PatternType.grape, Colour.pink, getCdnUrl('pattern-grape-pink.jpg')],
  [PatternType.grape, Colour.blue, getCdnUrl('pattern-grape-blue.jpg')],
  [
    PatternType.grape,
    Colour.steelBlue,
    getCdnUrl('pattern-grape-steelblue.jpg'),
  ],
  [PatternType.grape, Colour.yellow, getCdnUrl('pattern-grape-yellow.jpg')],
  [PatternType.grape, Colour.orange, getCdnUrl('pattern-grape-orange.jpg')],
  [
    PatternType.grape,
    Colour.lightPink,
    getCdnUrl('pattern-grape-light-pink.jpg'),
  ],
  [
    PatternType.flamingo,
    Colour.turquoise,
    getCdnUrl('pattern-flamingo-turquoise.jpg'),
  ],
  [
    PatternType.flamingo,
    Colour.lightTurquoise,
    getCdnUrl('pattern-flamingo-turquoise.jpg'),
  ],
  [PatternType.flamingo, Colour.mint, getCdnUrl('pattern-flamingo-mint.jpg')],
  [PatternType.flamingo, Colour.green, getCdnUrl('pattern-flamingo-green.jpg')],
  [
    PatternType.flamingo,
    Colour.purple,
    getCdnUrl('pattern-flamingo-purple.jpg'),
  ],
  [PatternType.flamingo, Colour.pink, getCdnUrl('pattern-flamingo-pink.jpg')],
  [PatternType.flamingo, Colour.blue, getCdnUrl('pattern-flamingo-blue.jpg')],
  [
    PatternType.flamingo,
    Colour.steelBlue,
    getCdnUrl('pattern-flamingo-steelblue.jpg'),
  ],
  [
    PatternType.flamingo,
    Colour.yellow,
    getCdnUrl('pattern-flamingo-yellow.jpg'),
  ],
  [
    PatternType.flamingo,
    Colour.orange,
    getCdnUrl('pattern-flamingo-orange.jpg'),
  ],
  [
    PatternType.flamingo,
    Colour.lightPink,
    getCdnUrl('pattern-flamingo-light-pink.jpg'),
  ],
  [
    PatternType.sprinkles,
    Colour.turquoise,
    getCdnUrl('pattern-sprinkles-turquoise.svg'),
  ],
  [
    PatternType.sprinkles,
    Colour.lightTurquoise,
    getCdnUrl('pattern-sprinkles-turquoise.svg'),
  ],
  [PatternType.sprinkles, Colour.mint, getCdnUrl('pattern-sprinkles-mint.svg')],
  [
    PatternType.sprinkles,
    Colour.green,
    getCdnUrl('pattern-sprinkles-green.svg'),
  ],
  [
    PatternType.sprinkles,
    Colour.purple,
    getCdnUrl('pattern-sprinkles-purple.svg'),
  ],
  [PatternType.sprinkles, Colour.pink, getCdnUrl('pattern-sprinkles-pink.svg')],
  [PatternType.sprinkles, Colour.blue, getCdnUrl('pattern-sprinkles-blue.svg')],
  [
    PatternType.sprinkles,
    Colour.steelBlue,
    getCdnUrl('pattern-sprinkles-steelblue.svg'),
  ],
  [
    PatternType.sprinkles,
    Colour.yellow,
    getCdnUrl('pattern-sprinkles-yellow.svg'),
  ],
  [
    PatternType.sprinkles,
    Colour.orange,
    getCdnUrl('pattern-sprinkles-orange.svg'),
  ],
  [
    PatternType.sprinkles,
    Colour.lightPink,
    getCdnUrl('pattern-sprinkles-light-pink.svg'),
  ],
  [
    PatternType.sprinkies,
    Colour.turquoise,
    getCdnUrl('pattern-sprinkies-turquoise.svg'),
  ],
  [
    PatternType.sprinkies,
    Colour.lightTurquoise,
    getCdnUrl('pattern-sprinkies-turquoise.svg'),
  ],
  [PatternType.sprinkies, Colour.mint, getCdnUrl('pattern-sprinkies-mint.svg')],
  [
    PatternType.sprinkies,
    Colour.green,
    getCdnUrl('pattern-sprinkies-green.svg'),
  ],
  [
    PatternType.sprinkies,
    Colour.purple,
    getCdnUrl('pattern-sprinkies-purple.svg'),
  ],
  [PatternType.sprinkies, Colour.pink, getCdnUrl('pattern-sprinkies-pink.svg')],
  [PatternType.sprinkies, Colour.blue, getCdnUrl('pattern-sprinkies-blue.svg')],
  [
    PatternType.sprinkies,
    Colour.steelBlue,
    getCdnUrl('pattern-sprinkies-steelblue.svg'),
  ],
  [
    PatternType.sprinkies,
    Colour.yellow,
    getCdnUrl('pattern-sprinkies-yellow.svg'),
  ],
  [
    PatternType.sprinkies,
    Colour.orange,
    getCdnUrl('pattern-sprinkies-orange.svg'),
  ],
  [
    PatternType.sprinkies,
    Colour.lightPink,
    getCdnUrl('pattern-sprinkies-light-pink.svg'),
  ],
]

export function getImage(patternType: PatternType, color: Colour): string {
  for (const [pt, c, img] of images) {
    if (patternType === pt && color === c) {
      return img
    }
  }
  return ''
}

export interface IPageState {
  color: Colour
  patternImage: string
}

export const initialPage: IPageState = {
  color: Colour.blue,
  patternImage: getImage(PatternType.grape, Colour.blue),
}

export const CHANGE_COLOR = 'CHANGE_COLOR'
export const RANDOM_COLOR = 'RANDOM_COLOR'

export function changePageColor(color: Colour) {
  return {
    type: CHANGE_COLOR,
    color,
  }
}

export function randomPageColor() {
  return {
    type: RANDOM_COLOR,
  }
}

export function pageReducer(state = initialPage, action: AnyAction) {
  switch (action.type) {
    case CHANGE_COLOR:
      return {
        color: action.color,
        patternImage: getImage(getRandomPatternType(), action.color),
      }
    case RANDOM_COLOR:
      const color = getRandomColor()
      return {
        color,
        patternImage: getImage(getRandomPatternType(), color),
      }
    default:
      return state
  }
}
